import React from "react";
import "../App.css";
import ReactTooltip from "react-tooltip";
import { resetAllIds } from "../idGenerator";
import ReactGA from 'react-ga';
import FeedbackMeter from "./FeedbackMeter";

class CompilerError extends React.Component {
    constructor(props) {
        super(props);
        resetAllIds();
        ReactGA.pageview(window.location.pathname + window.location.search);
    }

    render() {
        return (
            <div
                className="App"
                style={{ fontSize: `${this.props.fontSize}pt` }}
                onClick={(event) => { if (event.target.tagName === "A") { this.sendLinkAnalytics(event.target); } }}
            >
                <div className="AppContent">
                    {!this.props.embed && <div className="Title">
                        <h2>
                            {this.props.title}
                        </h2>
                    </div>}

                    <h4 className="Translation">
                        <i>
                            Translation: {this.props.translation}
                        </i>
                    </h4>

                    <ReactTooltip id="checkbox-tooltip" />
                    <ReactTooltip id="openclose-tooltip" />
                    {this.props.children}
                    <FeedbackMeter/>
                </div>
            </div>
        );
    }

    sendLinkAnalytics(elm) {
        ReactGA.event({
            category: "link",
            label: elm.href,
            action: "click"
        });
    }
}

export default CompilerError;
